import React from 'react';;

export interface ProviderContext {
  isRequest: boolean;
}

// @ts-ignore
export default React.createContext<ProviderContext>();